import React from "react";
import { toLower } from "lodash";
import { Flex } from "../../components/Flex";
import { FixedForm } from "../../components/Forms";
import { Label, Paragraph, Title } from "../../components/Text";
import { Scrollbar } from "../../components/Scrollbar";
import { isNone } from "../../utils";

const ShcRule = ({ onClose, data }) => {

    const fields = [
        { label: "title", attr: "title" },
        { label: "category", attr: "category" },
        { label: "evidence", attr: "evidence" },
        { label: "keywords", attr: "keywords" },
        { label: "os", attr: "os" },
        { label: "os status", attr: "osStatus" },
        { label: "last reviewed", attr: "lastReviewed" },
        { label: "description", attr: "description" },
        { label: "algorithm", attr: "algorithm" },
        { label: "submit date", attr: "submitDate" },
        { label: "submitted by", attr: "submittedBy" },
        { label: "comment", attr: "comment" },
        { label: "log", attr: "log", render: d => d.split("$").map((part, idx) => {
            return part.trim().length && toLower(part) !== "none"
                ? <Flex key={idx} >
                    <Label size={14} capitalize style={{ width: "66px"}}>{toLower(part.split(": ")[0])}</Label>
                    <Paragraph nowrap>{part.split(": ")[1]}</Paragraph>
                </Flex>
                : part
        })}
    ];


    return(
        <FixedForm onClose={onClose}>
            <Title h4 style={{marginBottom: "18px"}}>{data.ruleId}</Title>
            <Flex height="100%">
                <Scrollbar>
                    <Flex direction="column" gap={{ bottom: 14 }} height="100%">
                        {fields.map(field => (
                            <Flex key={field.attr} direction="column" gap={{ bottom: 2 }}>
                                <Label size={14} bold>{field.label}</Label>
                                {data && data[field.attr] && !isNone(data[field.attr])
                                    ? field.render
                                        ? field.render(data[field.attr])
                                        : <Paragraph>{data[field.attr]}</Paragraph>
                                    : <Paragraph>&mdash;</Paragraph> }
                            </Flex>
                        ))}
                    </Flex>
                </Scrollbar>
            </Flex>
        </FixedForm>
    )
};

export { ShcRule };